export default "__VITE_ASSET__9125058f__"